import React from "react";
import downIcon from "../../../../assets/images/classes/downIcon.svg";

const DropDownLevel = ({ openDropdown, setOpenDropdown , curriculumData, level, setSelectedChapter}) => {

    const isOpen = openDropdown === "level";

    const selectLevel = (item) => {
        const chapterSelected = {
            level: item.level,
            supremeChapterSeq: 0, // 상위 챕터 ID
            chapterSeq: 0, // 현재 선택된 챕터 ID
        };
        setSelectedChapter(chapterSelected);
        setOpenDropdown(false);
    }

    return (
        <div className="relative">
            <button
                onClick={() => setOpenDropdown(isOpen ? null : "level")}
                className="inline-flex w-[200px] h-[44px] justify-center items-center gap-x-0 rounded-[10px] bg-white px-3 py-2 font-[500] text-[16px] text-[#000] shadow-custom ring-1 ring-inset ring-gray-300 hover:bg-gray-50 z-20 relative"
            >
                <div className="flex items-center relative left-0 right-0 text-left w-full">
                    <div className="inline-block border-[1px] border-solid border-[#C8C8CF] rounded-[200px] w-[60px] py-[3px] text-[12px] text-[#9B9BA1] text-center">{level ? level.level+"레벨" : "레벨 선택"}</div>
                    <div className="ml-[6px] inline-block"> {level ? level.levelExplanation : ""}</div>
                </div>
                <img src={downIcon} alt="downIcon" className="ml-auto w-4" />
            </button>

            {isOpen && (
                <div className="absolute w-full z-10 origin-top rounded-b-[10px] bg-white shadow-lg ring-1 ring-black/5 transition-all duration-300 overflow-hidden">
                    <div className="max-h-[300px] overflow-y-auto bg-[#F1F1F1]">
                        {curriculumData && curriculumData.map((item, index) => (
                            <div
                                key={index}
                                onClick={() => selectLevel(item)}
                                className="cursor-pointer hover:bg-blue-50 p-2"
                            >
                                <div
                                    className=" inline-block">{item.level + "레벨"} -</div>
                                <div className="ml-[6px] inline-block"> {item.levelExplanation}</div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DropDownLevel;
